module.exports = __webpack_public_path__ + "static/media/acc-icon1.8cbd009f.svg";